<template>
    <div>
        <ejs-grid ref='grid' :dataSource='data' :allowResizing='true' >
            <e-columns>
                <e-column field='pkgType' :headerText='$t("Software.pkgType")' width='8%'></e-column>
                <e-column field='pkgMode' :headerText='$t("Software.pkgMode")' width='5%' ></e-column>
                <e-column field='pkgVer' :headerText='$t("Software.td_packageVer")' width='10%' ></e-column>
                <e-column field='mainPkgVer' :headerText='$t("Software.td_mainPkgVer")' width='10%' ></e-column>
                <e-column field='result' :headerText='$t("Software.td_result")' width='8%' :valueAccessor='resultFormatter'></e-column>
                <e-column field='failReasonString' :headerText='$t("Software.td_detail")' width='8%' ></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>

<script>
import { stringify } from 'querystring';
import { Resize } from "@syncfusion/ej2-vue-grids";
export default {
  name: 'detail-list',
  data() {
    return {
      data: [],
      resultmap: new Map(
        [    
            [0,this.$t('Software.dl_noneed')],
            [1,this.$t('Software.dl_already')],
            [2,this.$t('Software.dl_succ')],
            [3,this.$t('Software.dl_fail')],
        ]),
    };
  },
  provide: {
      grid: [Resize]
  },
  methods: {
    queryMethod(taskid) {
      let para={
          taskid: taskid,
          systemId: '1',
      }
      console.log('para',para)
      this.$axios.get(`/lte/ems/verupdate_new/updatetaskdetaildownload?${stringify(para)}`).then((response) => {
        if(response.data.errorCode == 'SUCCESS')
        {
          this.data = response.data.resultVal;
        }
        // else{
        //   this.$layer.alert({ msg:response.data.errorString} );
        // }
      });
    },
    resultFormatter(field, data, column){
        return this.resultmap.get(data['result']);
    },
  }
};
</script>